import { render, staticRenderFns } from "./c-reais.vue?vue&type=template&id=67761273&scoped=true"
import script from "./c-reais.vue?vue&type=script&lang=js"
export * from "./c-reais.vue?vue&type=script&lang=js"
import style0 from "./c-reais.vue?vue&type=style&index=0&id=67761273&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67761273",
  null
  
)

export default component.exports